<template>
  <v-list-item class="subtask-item">
    <template #prepend>
      <div class="checkbox-wrapper">
        <v-checkbox
          v-model="local.done"
          density="compact"
          hide-details
          @update:modelValue="emitUpdate"
        />
      </div>
    </template>

    <v-list-item-title class="subtask-title" :class="{ done: local.done }">
      {{ local.name }}
    </v-list-item-title>

    <template #append>
      <v-btn icon variant="text" @click="$emit('remove', subtask)">
        <v-icon color="error">mdi-delete</v-icon>
      </v-btn>
    </template>
  </v-list-item>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { Subtask } from "@/types";

const props = defineProps<{
  subtask: Subtask;
}>();

const emit = defineEmits(["update", "remove"]);

const local = ref({ ...props.subtask });

watch(
  () => props.subtask,
  (v) => (local.value = { ...v })
);

function emitUpdate() {
  emit("update", local.value);
}
</script>

<style scoped>
.subtask-item {
  align-items: center;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
  margin-right: 4px;
}

.subtask-title {
  line-height: 1.2;
}

.subtask-title.done {
  text-decoration: line-through;
  opacity: 0.6;
}
</style>
